import React from "react";

import { Formik } from "formik";
import { CircularProgress } from "@mui/material";

import "../../Assets/css/policy.css";
import "../../Assets/css/globalStyle.css";
import CategoryHeader from "../../Components/Headers/CategoryHeader";
import CreateQuoteForm from "../../Components/PersonalAccidentComponents/CreateQuoteForm/CreateQuoteForm";
import CreateQuoteStepper from "../../Components/PersonalAccidentComponents/CreateQuoteStepper/CreateQuoteStepper";
import useCreateQuote from "./useCreateQuote";

export default function CreateQuote() {
  // const { quickQuoteDetails } = useContext(QuickQuoteContext); // TODO: Working with local storage, need to some changes in reinitialize

  const {
    initialValues,
    validationSchema,
    steps,
    activeStep,
    setActiveStep,
    formConfigJSON,
    numberOfInsureds,
    disableBuy,
    handleBack,
    isLastStep,
    onSubmit,
  } = useCreateQuote();

  return (
    <div>
      <CategoryHeader title="Personal Accident Insurance" />
      <h3 className="fw-700 text-center my-4 heading-text text-capitalize">
        PROPOSAL FORM
      </h3>

      {/* TODO: make tabs responsive */}
      {/* Tabs */}
      <CreateQuoteStepper
        steps={steps}
        activeStep={activeStep}
        setActiveStep={setActiveStep} // TODO: useCreateQuote Hooks
      />
      {/* Form */}
      {initialValues ? (
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          enableReinitialize={false}
          onSubmit={onSubmit}
        >
          {(formik) => {
            console.log("formik values", formik);

            return (
              <CreateQuoteForm
                activeStep={activeStep}
                formConfigJSON={formConfigJSON}
                numberOfInsureds={numberOfInsureds}
                disableBuy={disableBuy}
                handleBack={handleBack}
                isLastStep={isLastStep}
              />
            );
          }}
        </Formik>
      ) : (
        // <Typography>Loading....</Typography>
        <CircularProgress
          size={48}
          sx={{
            color: "red",
          }}
        />
      )}
    </div>
  );
}
